export const DEFAULT_LANDING_PATH = '/landingpages/create/ai-chat'
export const PAID_ANALYTICS_PATH = '/analytics/paid'
export const EMAIL_ANALYTICS_PATH = '/analytics/email'
